import styles from './index.module.scss';
import MainButton from '../mainButton';
import OTP from '../otp';
import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';

export function OTPStep({ email, minutes = 1, handleOTPSubmit, setOTP, handleResendOTP, children }) {
  const [tick, setTick] = useState(minutes * 60);
  const [timerId, setTimerId] = useState();
  const [showResend, setShowResend] = useState(false);
  const [resetOTP, setResetOTP] = useState(false);
  const [disableButton, setDisableButton] = useState(true);
  const dispatch = useDispatch();
  const hasStarted = useRef(false);
  
  useEffect(() => {
    if (!hasStarted?.current) {
      hasStarted.current = true;
      const timer = setInterval(() => {
        setTick(prev => prev - 1);
      }, 1000)
      setTimerId(timer);
    }
    return () => {
      clearInterval(timerId);
    }
  }, []);

  useEffect(() => {
    if (tick === 0) {
      clearInterval(timerId);
      setShowResend(true);
    }
  },[tick])

  const getTimer = () => {
    const minutes = Math.floor(tick / 60) % 60;
    const seconds = tick % 60;
    return `${minutes.toString().padStart(2,'0')}:${seconds.toString().padStart(2,'0')}`
  };
  const handleOTPComplete = (otp) => {
    setDisableButton(false);
    setOTP(otp);
  };
  const handleOTPIncomplete = () => {
    setDisableButton(true);
    setOTP('')
  };

  const resendOTP = async () => {
    // const response = await handleResendOTP();
    // if (response.status === 200) {
    //   setResetOTP(true);
    //   setShowResend(false);
    //   setTick(minutes * 60);
    //   setOTP('');
    //   const timer = setInterval(() => {
    //     setTick(prev => prev - 1);
    //   }, 1000);
    //   setTimerId(timer);
    //   setDisableButton(true);
    // } else {
    // }
  }

  return (
    <section className={styles['otp-step']}>
      <div className={styles['otp-step-content']}>
        <h3 className={styles['otp-step-content-title']}>Verification code</h3>
        <p className={styles['otp-step-content-body']}>Please enter 4 digit code you received on your Email {email}</p>
        <div className={styles['otp-step-input-container']}>
          <OTP
            length={4}
            resetOTP={resetOTP}
            onComplete={handleOTPComplete}
            inComplete={handleOTPIncomplete}
          />
          {!showResend && 
            <p className={styles['otp-step-resend-text']}>
              you can resend OTP in <span>{getTimer()}</span>
            </p>
          }
          {showResend &&
            <p className={styles['otp-step-resend-text']}>
              click here to
              <button
                className={styles['otp-step-resend']}
                onClick={resendOTP}
              >
                Resend OTP
              </button>
            </p>
          }
        </div>
        <div className={styles['otp-step-actions']}>
          <MainButton disabled={disableButton} handleSubmit={handleOTPSubmit}>Continue</MainButton>
          {children}
        </div>
      </div>
    </section>
  )
}

export default OTPStep;